import { useContext } from "react";
import { TreeContext } from "./Tree.context";
import { TreeContextValue, WithId } from "./Tree.types";

export function useTreeContext<T extends WithId>(): TreeContextValue<T> {
    return useContext(TreeContext);
}
